import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class OrderDetailDto {
  @ApiProperty()
  Id!: number;

  @ApiProperty()
  StatusName!: string;

  @ApiProperty()
  BookingNumber!: string;

  @ApiProperty()
  CustomerName!: string;

  @ApiProperty()
  ShipperName!: string;

  @ApiPropertyOptional()
  ConsigneeName?: string | null;

  @ApiPropertyOptional()
  CustomerReference?: string | null;

  @ApiProperty()
  CarrierVesselVoyage!: string;

  @ApiProperty({ enum: ['Contenedor', 'Pallet'] })
  TypeOfShipmentName!: 'Contenedor' | 'Pallet';

  @ApiProperty()
  PortOfLoadingName!: string;

  @ApiPropertyOptional()
  TerminalName?: string | null;

  @ApiPropertyOptional()
  PortOfDischargeName?: string | null;

  @ApiProperty()
  CarrierFullName!: string;

  @ApiPropertyOptional()
  CustomerContractName?: string | null;

  // Financial Data (Formatted Strings)
  @ApiProperty({ description: 'Valor Neto formateado' })
  NetValue!: string;

  @ApiProperty()
  NetValueCurrencyCode!: string;

  @ApiProperty({ description: 'Extra Costos formateado' })
  ExtraCosts!: string;

  @ApiProperty()
  ExtraCostsCurrencyCode!: string;

  @ApiPropertyOptional()
  ServiceName?: string | null;

  @ApiProperty()
  CurrencyCode!: string;

  // Total calculado en backend (Formatted Strings)
  @ApiPropertyOptional({ description: 'Total calculado formateado' })
  TotalValue?: string | null;

  @ApiPropertyOptional()
  TotalValueCurrencyCode?: string | null;

  @ApiProperty()
  HasMixedCurrencies!: boolean;
}

export class TransportOrderItemDto {
  @ApiProperty()
  Id!: number;

  @ApiProperty()
  ItemStatusName!: string;

  @ApiProperty({ enum: ['Contenedor', 'Pallet'] })
  TypeOfShipmentName!: 'Contenedor' | 'Pallet';

  @ApiPropertyOptional()
  ContainerNumber?: string | null;

  @ApiPropertyOptional()
  CarrierSealNumber?: string | null;

  @ApiPropertyOptional()
  TypeOfContainerName?: string | null;

  @ApiPropertyOptional()
  ContainerTare?: string | null; // Formatted

  @ApiPropertyOptional()
  QuantityOfPallets?: number | null;

  @ApiPropertyOptional()
  TruckLicensePlate?: string | null;

  @ApiPropertyOptional()
  TrailerTruckLicensePlate?: string | null;

  @ApiPropertyOptional()
  FirstDispatchPlantName?: string | null;

  @ApiPropertyOptional()
  FirstDispatchPlantLocationName?: string | null;

  @ApiPropertyOptional({ description: 'Fecha formatted' })
  FirstDispatchPlantCitationDate?: string | null;

  @ApiPropertyOptional()
  DepotName?: string | null;

  @ApiPropertyOptional()
  CrossContainerWithdrawalIndicatorName?: string | null;

  @ApiPropertyOptional()
  GateOutDepotInAdvanceIndicatorName?: string | null;

  @ApiPropertyOptional()
  InlandTransportProviderName?: string | null;

  @ApiPropertyOptional()
  InlandTransportProviderInvoiceNumber?: string | null;

  @ApiPropertyOptional({ description: 'Costo formateado' })
  InlandTransportProviderCostAmount?: string | null;

  @ApiPropertyOptional()
  InlandTransportProviderCostAmountCurrencyCode?: string | null;

  @ApiPropertyOptional()
  RemarksGateOutDepot?: string | null;

  // Agenda (Formatted Dates)
  @ApiPropertyOptional()
  GateOutDepotDate?: string | null;

  @ApiPropertyOptional()
  GateInDepotDate?: string | null;

  @ApiPropertyOptional()
  GateInTerminalDate?: string | null;

  @ApiPropertyOptional()
  GateOutTerminalDate?: string | null;

  @ApiPropertyOptional()
  GateInStackingDate?: string | null;

  // New Milestones (Formatted Dates)
  @ApiPropertyOptional()
  GateInDate?: string | null;

  @ApiPropertyOptional()
  GateOutDate?: string | null;

  @ApiPropertyOptional({ description: 'Visación — fecha de inspección SAG' })
  SAGCustomsInspectionDate?: string | null;
}

export class ServiceOrderDto {
  @ApiProperty()
  Id!: number;

  @ApiPropertyOptional()
  ServiceName?: string | null;

  @ApiPropertyOptional()
  TypeOfServiceName?: string | null;

  @ApiPropertyOptional()
  CategoryOfServiceName?: string | null;

  @ApiPropertyOptional()
  StatusName?: string | null;

  @ApiProperty()
  Quantity!: number;

  @ApiPropertyOptional({ description: 'Precio formateado' })
  UnitSellingPriceAmount?: string | null;

  @ApiPropertyOptional({ description: 'Neto formateado' })
  UnitSellingPriceTotalNetAmount?: string | null;

  @ApiPropertyOptional({ description: 'IVA formateado' })
  UnitSellingPriceTotalVatAmount?: string | null;

  @ApiPropertyOptional({ description: 'Total formateado' })
  UnitSellingPriceTotalPaymentAmount?: string | null;

  @ApiPropertyOptional()
  UnitSellingPriceCurrencyCode?: string | null;

  @ApiPropertyOptional()
  ReferenceValue?: string | null;

  @ApiPropertyOptional()
  TransportOrderItemId?: number | null;
}

export class TransportOrderDetailResponseDto {
  @ApiProperty({ type: OrderDetailDto })
  order!: OrderDetailDto;

  @ApiProperty({ type: [TransportOrderItemDto] })
  items!: TransportOrderItemDto[];

  @ApiProperty({ type: [ServiceOrderDto] })
  serviceOrders!: ServiceOrderDto[];
}
